import zh from './zh'
import en from './en'
import tc from './tc'
import fr from './fr'
import de from './de'
import es from './es'
import it from './it'
import pt from './pt'
import ru from './ru'
import th from './th'
import React from 'react'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'
import { OmniHeroesCommunity } from '@/types'

export interface Locales {
    [key: string]: {
        [key: string]: string
    }
}


export const locales: Locales = {
    zh,
    en,
    ch:zh,
    tw:tc,
    hk: tc,
    fr,
    de,
    es,
    it,
    pt,
    ru,
    th
}

export function getLanguage(language: string) {
    return locales[language]
}

interface IntlProps {
    language: string,
}

class Intl extends React.Component<IntlProps> {
    render() {
        const  { language } = this.props
        return (
            <IntlProvider locale={language} key={language} messages={getLanguage(language)}>
                   { this.props.children }
            </IntlProvider>
        )
    }
}

const mapProps = (state: OmniHeroesCommunity.RootState) => {
    return {
        language: state.user.language
    }
}

export default connect(mapProps)(Intl)
